export default __webpack_public_path__ + "static/media/cup-without-handle.e53a0d5e.png";